import React, { memo, ReactNode, ReactElement, useContext, useRef } from "react";
import { withStyles, ScreenTransition } from "@swiggy-private/core-ui";
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";
import styles from "./PaymentModesWrapper.scss";
import { CheckoutRoute, HardwareBackContext } from "@swiggy-private/checkout-core";
import { useOnBack } from "@swiggy-private/checkout-core";

interface PaymentModesWrapperProps {
    children: ReactNode;
    title: string;
    headerExtraContent?: React.ReactElement;
    containerClassName?: string;
    headerClassName?: string;
    backButtonClass?: string;
}

export interface ScrollableDivElement extends HTMLDivElement {
    getScrollPosition: () => number;
}

function PaymentsHeaderContent(props: Omit<PaymentModesWrapperProps, "children">): ReactElement {
    return <CommonHeaderContent title={props.title} />;
}

function PaymentModesWrapper({ children, ...props }: PaymentModesWrapperProps): React.ReactElement {
    const { state: hardwareBackState, setState: setHardwareBackState } = useContext(HardwareBackContext);
    const onBack = useOnBack();

    // TODO: Move to hooks
    if (hardwareBackState.shouldHandle && hardwareBackState.activeRoute === CheckoutRoute.SECURE_CARD) {
        onBack();
        setHardwareBackState({
            shouldHandle: false,
            activeRoute: "",
        });
    }

    const containerRef = useRef<ScrollableDivElement>(null);

    return (
        <ScreenTransition>
            <CommonUIWrapper
                // onBack={_onBack}
                header={<PaymentsHeaderContent {...props} />}
                content={children}
                key={0}
                ref={containerRef}
                containerCSSClass={props.containerClassName}
                headerCSSClass={props.headerClassName}
                headerExtraContent={props.headerExtraContent}
                backButtonClass={props.backButtonClass}
            />
        </ScreenTransition>
    );
}

export default memo(withStyles(PaymentModesWrapper, styles));
